import React, { useState, useEffect, useMemo, useContext } from 'react';
import { Box } from '@mui/material';
import PageHeader from '@/components/PageHeader';
import { Table, DatePicker } from '@alifd/next';
import EditButton from '@/components/dynamicComponent/Buttons/EditButton';
import { fieldGenerator } from '@/lib/dynamicTable';
import locale from 'antd/es/date-picker/locale/zh_TW';
import moment from 'moment';
import client from '@/lib/feathers';
import axios from 'axios';
import EditAbsence from '@/components/UI/EditAbsence';
import { BackStageContext } from '@/contexts/BackStageContext';

export default function AbsenceRecord({ showHeader = true }) {
  const [isUpdate, setIsUpdate] = useState(false);
  const [dataSource, setDataSource] = useState([]);
  const [pickedMonth, setPickedMonth] = useState(moment());
  const [workerOptions, setWorkerOptions] = useState([
    { value: '', label: '' },
  ]);
  const [clientData, setClientData] = useState(null);
  const { backStageUpdateTrigger } = useContext(BackStageContext);

  useEffect(() => {
    const getWorkers = async () => {
      const workers = (
        await client.service('menuWorkers').find({ query: { activated: true } })
      ).data;
      setWorkerOptions(
        workers.map((worker) => ({
          value: worker._id,
          label: worker.name,
        }))
      );
    };
    getWorkers();
  }, [backStageUpdateTrigger]);
  useEffect(() => {
    (async () => {
      const res = await client.service('categoryMenu').find({
        query: {
          service: 'absenceType',
        },
      });
      setClientData(res.data[0].data);
    })();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get(
          `/ezcon/api/smartingBuildingGetWorkersAbsence?searchTime=${pickedMonth.valueOf()}`,
          {
            headers: {
              authorization: localStorage.getItem('feathers-jwt'),
            },
          }
        );
        setDataSource(res.data);
      } catch (error) {
        console.error(error);
      }
    };
    fetchData();
  }, [isUpdate, pickedMonth]);

  const columns = useMemo(
    () => [
      {
        title: '公司名稱',
        dataIndex: 'companyName',
        key: 'companyName',
        width: 150,
        lock: 'left',
      },
      {
        title: '員工姓名',
        dataIndex: 'workerName',
        key: 'workerName',
        width: 150,
        lock: 'left',
      },
      {
        title: '出缺勤記錄',
        children: new Array(pickedMonth.daysInMonth())
          .fill('')
          .map((_, index) => ({
            title: `${index + 1}`,
            dataIndex: 'monthAbsenceCondition',
            width: 70,
            align: 'center',
            cell: (val) => val[index + 1] || '',
          })),
      },
      {
        title: '總計',
        dataIndex: 'monthAbsenceSummary',
        key: 'monthAbsenceSummary',
        lock: 'right',
        width: 200,
      },
    ],
    [pickedMonth]
  );

  const inputFields = useMemo(
    () => ({
      worker: fieldGenerator('workerId', '員工', 'Select', {
        options: workerOptions,
      }),
      type: fieldGenerator('type', '請假類型', 'Select', {
        options: clientData?.map((item) => ({
          value: item.name,
          label: item.name,
        })),
      }),
      period: fieldGenerator('period', '請假時間', 'RangePicker', {
        locale,
        format: 'YYYY/MM/DD',
      }),
      remark: fieldGenerator(
        'remark',
        '備註',
        'TextArea',
        {},
        {
          rules: [],
        }
      ),
    }),
    [workerOptions, clientData]
  );

  return (
    <Box>
      {/* header */}
      {showHeader && (
        <PageHeader
          title="協力廠商名單"
          breadcrumbs={[{ name: '組織管理' }, { name: '協力廠商名單' }]}
        />
      )}
      {/* 新增出缺勤記錄按鈕 */}
      <EditButton
        {...{
          dbName: 'workersAbsence',
          fields: inputFields,
          func: { text: '新增出缺勤記錄' },
          defaultValue: {},
          setIsUpdate,
        }}
      />
      {/* 出缺勤列表 */}
      <EditAbsence />
      {/* 選擇月份 */}
      <DatePicker.MonthPicker
        value={pickedMonth}
        onChange={(date) => setPickedMonth(date)}
        format="YYYY/MM"
        locale={locale}
        style={{ marginLeft: '20px' }}
      />
      <Box
        sx={{
          borderRadius: '4px',
          mt: '20px',
          p: '20px',
          backgroundColor: '#fff',
          display: 'flex',
          flexDirection: 'column',
          gap: '20px',
        }}
      >
        <Table
          dataSource={dataSource}
          columns={columns}
          fixedHeader
          maxBodyHeight={500}
        />
      </Box>
    </Box>
  );
}
